import React from "react";
import SearchFormView from "./SearchFormView";
import EmblaCarousel from "./EmblaCarousel";

export default function HomeView({ query, setQuery, onSearch, loading, artworks }) {
  return (
    <div className="home-view">
      <h1 className="home-title">Welcome to ArtXplorer!</h1>
      <div className="search-container">
        <SearchFormView
          query={query}
          setQuery={setQuery}
          onSearch={onSearch}
          loading={loading}
        />
      </div>
      <div className="carousel-container">
        {artworks.length > 0 && <EmblaCarousel slides={artworks} />}
      </div>
    </div>
  );
}

